module.exports = __webpack_public_path__ + "img/zuopin3.2f1be541.jpg";